import { ref } from 'vue';

const isLoadingGlobal = ref(false);

export function useLoading() {
  return {
    isLoadingGlobal,
    showLoading: () => (isLoadingGlobal.value = true),
    hideLoading: () => (isLoadingGlobal.value = false),
  };
}